module.exports = __webpack_public_path__ + "img/18000.9b9c19fb.jpg";